<template>
  <AuthLayout :mode="mode">
    <Section
      heading="PowerLoad"
      description="Use this page to enter equipment into our database for others to find when they PowerSearch AND to email this info to all dealers who have signed up to receive that manufacturer's listings. We suggest you use our <a href='/members/broadcast-email' class='text-primary-100 font-semibold underline'>PowerCast</a> instead as it let's you send out your Buys/Sells in a free format."
      :mode="mode"
    />
    <div class="grid grid-cols-2 gap-6 sm:grid-cols-1 sm:gap-4">
      <Step
        v-for="(step, key) in steps"
        :mode="mode"
        :key="key"
        :step="step"
        @isExample="handleExample"
      />
    </div>
    <div class="mt-[48px] sm:mt-[32px]">
      <AppCard :mode="mode" title="Upload your Inventory File">
        <template #body>
          <div class="grid gap-6 sm:gap-4">
            <Notes :list="notesList" />
            <UploadForm :mode="mode" />
          </div>
        </template>
      </AppCard>
    </div>
  </AuthLayout>
</template>

<script>
import Section from "@C/Common/Section.vue";
import Notes from "@C/Common/Notes.vue";
import UploadForm from "@C/Upload/UploadForm.vue";
import AppCard from "@C/Common/AppCard.vue";
import AuthLayout from "@A/AuthLayout.vue";
import Step from "@C/Upload/Step.vue";

export default {
  name: "Upload",
  components: {
    AuthLayout,
    Section,
    Notes,
    UploadForm,
    AppCard,
    Step,
  },
  props: {
    mode: String,
  },
  data() {
    return {
      isExample: false,
      notesList: [
        "After uploading via PowerLoad, wait about 3 minutes.",
        "Use PowerSearch to check if one of your uploaded items appears.",
        "If it does — the upload was successful.",
        'If you’re experiencing issues or prefer us to handle the upload, please email your file to: <a class="text-primary-100 underline" href="mailto:post@ascdi.com">post@ascdi.com</a>',
      ],
      steps: [
        {
          number: 1,
          title: "Start with a Spreadsheet",
          description:
            "Put the equipment you have for sale into a spreadsheet using a program like Microsoft Excel",
          isDisabled: false,
        },
        {
          number: 2,
          title: "Add Required Fields",
          description:
            "Use any column headings you wish, but make sure to have a field called SELL (or BUY) for each record",
          isForExample: true,
          isDisabled: false,
        },
        {
          number: 3,
          title: "Save as .csv Format",
          description:
            "Save your file as a WINDOWS.csv file (You can do this in Mircrosoft Excel)",
          isDisabled: false,
        },
        {
          number: 4,
          title: "Choose Upload Method",
          description:
            "Click on overwrite to replace the inventory you currently have listed on the eTN or append to add to your existing lists",
          isDisabled: false,
        },
      ],
    };
  },
  methods: {
    handleExample(value) {
      this.isExample = value;
      this.steps.forEach((step) => {
        if (!step.isForExample) {
          step.isDisabled = this.isExample;
        }
      });
    },
  },
};
</script>
